export type CookieConsent = {
  analytics: boolean | null; // null = no decision yet
  ts: string;                // ISO timestamp
};

const STORAGE_KEY = 'lumiplot_cookie_consent_v1';

export function getConsent(): CookieConsent {
  if (typeof window === 'undefined') {
    return { analytics: null, ts: '' };
  }
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return { analytics: null, ts: '' };
    }
    const parsed = JSON.parse(stored) as CookieConsent;
    // Validate structure
    if (typeof parsed !== 'object' || parsed === null) {
      return { analytics: null, ts: '' };
    }
    return {
      analytics: typeof parsed.analytics === 'boolean' ? parsed.analytics : null,
      ts: typeof parsed.ts === 'string' ? parsed.ts : '',
    };
  } catch {
    return { analytics: null, ts: '' };
  }
}

export function setConsent(analytics: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const consent: CookieConsent = {
      analytics,
      ts: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    // Keep compatibility for legacy code
    (window as any).lumiConsent = analytics;
  } catch {
    // Silently fail if localStorage is not available
  }
}

export function syncConsentToWindow(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const consent = getConsent();
  // If analytics is null (no decision), do NOT set window.lumiConsent (leave it undefined)
  if (consent.analytics === true || consent.analytics === false) {
    (window as any).lumiConsent = consent.analytics;
  }
}

export function hasAnalyticsConsent(): boolean {
  return getConsent().analytics === true;
}

